import { Signal } from '@angular/core';
import { FileInfo } from '@app/shared/types/models/files/file-info';

export interface ProjectLocationEditDialogData {
  projectLocationToEdit: Location;
}

export interface AddProjectLocationDialogData {
  parentId: string;
  projectId: string;
}

export interface ChangeLocationParentDialogData {
  location: Location;
  locations: Signal<Location[]>;
}

export interface DuplicateLocationsDialogData {
  locationsToDuplicate: Location[];
  locations: Signal<Location[]>;
}

/** Signal Forms model of the add / edit single location dialogs. */
export interface LocationNameFormModel {
  name: string;
}

/** Signal Forms model of the add multiple locations dialog (numbers come from DS number inputs). */
export interface AddMultipleLocationsFormModel {
  name: string;
  amount: number | null;
  numbering: number | null;
}

export interface SelectSingleLocationDialogData {
  locations: Location[];
  projectId: string;
  selectedLocation?: Location;
  isReadonly?: boolean;
  showEditButton?: boolean;
  isEmptyOptionEnabled?: boolean;
  title?: string;
}

export class Location {
  public id: string | undefined;
  public name: string | undefined;
  public parentLocation?: Signal<Location>;
  public projectId: string | undefined;
  public childrenCount: Signal<number>;
  public orderNo: number | undefined;
  public readOnly: boolean | undefined;
  public files: Signal<FileInfo[]>;

  public constructor(value: Partial<Location>) {
    Object.assign(this, value);
  }

  public get locationsPath(): Location[] {
    if (!this.parentLocation || typeof this.parentLocation !== 'function') {
      return [this];
    }

    const parent = this.parentLocation();
    if (!parent) {
      return [this];
    }

    return parent.locationsPath.concat(this);
  }
}
